import { Inject, Injectable } from '@angular/core'
import { DepartmentControllerService, DepartmentDto, DepartmentMapBoundsDto } from '../../../../api/backend'
import { AuthContextStorageService } from '../../../../core/auth/auth-context-storage.service'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class DepartmentDataService {

    constructor(@Inject(DepartmentControllerService) private departmentControllerService: DepartmentControllerService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                ) {
    }

    getDepartmentMapBounds(departmentId): Observable<DepartmentMapBoundsDto> {
        return this.departmentControllerService.getDepartmentMapBounds(
            this.authContextStorageService.getProjectKey(),
            departmentId
        )
    }

    getDepartments(): Observable<Array<DepartmentDto>> {
        return this.departmentControllerService.getAllDepartments(
            this.authContextStorageService.getProjectKey(),
        )
    }
}